import { Component, OnInit, NgZone } from '@angular/core';
import { FirebaseMessagingService } from 'src/app/services/firebase-messaging/firebase-messaging.service';

@Component({
  selector: 'app-gamification',
  templateUrl: './gamification.component.html',
  styleUrls: ['./gamification.component.scss']
})
export class GamificationComponent implements OnInit {
  gamification_flag;
  constructor(
    private notification: FirebaseMessagingService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.notification.notifications_subject.subscribe(res => {
      this.ngZone.run(() => {

        if (res.payload['event_type'] == 'gamification') {
          this.gamification_flag = 1;
          setTimeout(() => {
            this.gamification_flag = 0
          }, res.payload['timeout'] || 5000)
        }
      })
    })
  }

}
